/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { ConsumerColors, consumerColors } from '../style/colors';

export type ConsumerAppConfigContext = Readonly<{
  /**
   * Configurable color palette
   */
  colors: ConsumerColors;

  /**
   * "Magic numbers" that we use for styling the app across different components.
   */
  layout: {
    // Max width for the entire page.
    maxAppWidth: number;

    header: {
      // Height of the mobile App header.
      mobileHeight: number;
    };

    // Section list config, smallViewWidth can be percentage
    sectionList: {
      smallViewWidth: string;
    };

    // Section view config
    sectionView: {
      // Padding for content below the header on mobile devices.
      mobileTopPadding: number;

      // Max width for doc requests, basic edits, tasks, and choosers.
      maxWidth: number;

      // Height of the SectionViewHeader.
      headerHeight: number;

      // Horizontal padding for section content
      horizontalPadding: number;
    };
  };
}>;

export const defaultAppConfig: ConsumerAppConfigContext = Object.freeze({
  colors: consumerColors,
  layout: {
    maxAppWidth: 1440,

    header: {
      mobileHeight: 56,
    },

    sectionList: {
      smallViewWidth: '33.3%',
    },

    sectionView: {
      mobileTopPadding: 10,
      horizontalPadding: 20,
      maxWidth: 520,
      headerHeight: 56,
    },
  },
});

export const ConsumerAppConfigContext = React.createContext<ConsumerAppConfigContext>(defaultAppConfig);
